export const CREATE_COMMON_TEXT_SUCCESS = 'CREATE_COMMON_TEXT_SUCCESS';

export const LIST_COMMON_TEXT_SUCCESS = 'LIST_COMMON_TEXT_SUCCESS';

export const DELETE_COMMON_TEXT_SUCCESS = 'DELETE_COMMON_TEXT_SUCCESS';
